export default __webpack_public_path__ + "static/media/arrow.a03af96e.svg";